import actions from '../../actionTypes';

export default id => {
  return {
    type: actions.SELECT_TAG,
    id
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/selectTag.js